export const careerImages = {
  hero: "/assets/images/careerhero.png",
  culture1: "/assets/images/careergreate1.png",
  culture2: "/assets/images/learn-collaborate 1.jpg",
  culture3: "/assets/images/team-beyond-borders 1.jpg",
  culture4: "/assets/images/orane 1.jpg",
  culture5: "/assets/images/better-businesses-a-more 1.jpg",
  employee: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=300&q=85",
  cta: "/assets/images/ctacareer.png"
};
